import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import clsx from 'clsx'
import { sanitizeFieldName } from '@/utils/sanitizedLabel'

type Props = {
	id: string
	placeholder?: string
	colSpan?: string
	label: string
	required: boolean
	formStyle: string
	register: UseFormRegister<any>
	errors: FieldErrors
	className?: string
}

export default function PhoneInput({
	id,
	required,
	label,
	colSpan = '1',
	formStyle,
	register,
	errors,
	className,
}: Props) {
	const fieldName = sanitizeFieldName(label)
	return (
		<div
			className={clsx(
				'form-component',
				{
					'2': 'colSpan2',
				}[colSpan]
			)}
		>
			<div
				className={clsx('form-element-container', formStyle === 'line' && 'line-style', className)}
				onClick={() => document.getElementById(id)?.focus()}
			>
				<input
					id={id}
					type="tel"
					className="input"
					placeholder={''}
					{...register(`${fieldName?.replace(/'/g, '&apos;')}`, {
						required: required,
					})}
				/>
			</div>
			<label htmlFor={id}>{`${label} ${required ? '*' : ''}`}</label>
			{errors && errors[fieldName] && (
				<span className="mt-1 text-red-500">
					{errors[fieldName]?.type === 'required'
						? `${label} is required`
						: errors[fieldName]?.message?.toString()}
				</span>
			)}
		</div>
	)
}
